import React from 'react';
import moment from 'moment';
import { buildYup } from 'schema-to-yup';
import Region from '../../../../../constants/region';
import { capitalize } from '../../../../../../utils';
import { FormController } from '../../../../../custom-components';
import FormCreator from '../../../../../configured-components/form/configured-inputs/form-creator/FormCreator';

export const ButtonSx = {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '14px',
};

export const GridContainerSx = {
    paddingY: 3,
    paddingX: 5,
    marginBottom: 2,
};

export const overrideGridSx = {
    paddingLeft: '16px',
    paddingBottom: 0,
};

export const FieldLabelSx = {
    opacity: 0.6,
    display: 'inline-block',
    width: 168,
    wordBreak: 'break-word',
};

export const FieldValueSx = {
    flex: 1,
    wordBreak: 'break-word',
};

export const ProcessorBaysSx = {
    containerSx: {
        paddingY: 0,
        paddingX: 5,
    },
    buttonContainerSx: {
        paddingX: 0,
        paddingY: 3,
    },
    bayCardSx: {
        maxWidth: '377px',
    },
};

export const renderFormCreator = ({ def, user, field, props }) => {
    const submitHandler = props?.submit;
    const validation = buildYup(
        def.config?.validation || {
            type: 'object',
            properties: {},
        },
        def.config?.validation_config || {
            errMessages: {},
        }
    );

    return (
        <div style={{ width: '100%' }}>
            <FormController
                key={field}
                schema={validation}
                defaultValues={{ ...user, id: user?.id ?? user?._id }}
                submit={submitHandler}
                handleCancel={() => {}}
                shouldUnregister
                submitText={props?.submitText || 'Save'}
                hideSubmit={props?.hideSubmit || false}
                hideCancel
                actionsProps={{
                    disablePadding: true,
                    buttonSx: ButtonSx,
                }}
                options={{
                    ...props?.options,
                }}
            >
                <FormCreator user={user} config={def.config} />
            </FormController>
        </div>
    );
};

export const snakeCaseToUpperCase = (value) => {
    if (!value) return '';
    return value.split('_').map(capitalize).join(' ');
};

export const NO_INVOICING_REGIONS = [Region.CDI, Region.LEGACY, Region.NL, Region.PRAIRIE];
export const NO_POOLING_REGIONS = [Region.CDI, Region.IMP, Region.LEGACY, Region.NL, Region.UDA];

export const findByMonth = (arr = [], selectedDate, dateKey = 'date') => arr.find((item) => item?.[dateKey] && moment(item[dateKey]).isSame(selectedDate || moment(), 'month')) || null;
